import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-01b4c1ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subtitle-1" }
const _hoisted_2 = { class: "subtitle-1" }
const _hoisted_3 = { class: "subtitle-1" }
const _hoisted_4 = { class: "wp-list" }
const _hoisted_5 = { class: "wp-flex" }
const _hoisted_6 = { class: "punishment-title" }
const _hoisted_7 = { class: "punishment" }
const _hoisted_8 = { class: "punishment-select" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "subtitle-1" }
const _hoisted_12 = { class: "subtitle-1" }
const _hoisted_13 = { class: "subtitle-1" }
const _hoisted_14 = { class: "test-buttons" }
const _hoisted_15 = { class: "test-result" }

import i18n from "@/plugins/i18n";
import SelectItems from "@/utils/SelectItems";
import {computed, Reactive, reactive, ref} from "vue";
import {Guild} from "@/types/Guild";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import {GuildAutoModeration, GuildSettings} from "@/types/GuildSettings";
import config from "@/config.json";
import AutoModeration from "@/components/automod/AutoModeration.vue";
import DurationPicker from "@/components/DurationPicker.vue";
import {SubmitResult} from "@/types/SubmitResult";
import {Command} from "@/types/Command";
import TemplateInput from "@/components/TemplateInput.vue";
import EmbedInput from "@/components/EmbedInput.vue";
import BoostAlert from "@/components/BoostAlert.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildModerationView',
  props: {
    settings: {}
  },
  emits: ['submitted'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const route = useRoute()
const store = useStore()
let guild = computed(() => (store.getters.guilds as Array<Guild>).find(g => g.id === route.params.id));
let roles = SelectItems.roles(guild.value!.roles!, false)
let commands = computed(() => (store.getters.commands as Array<Command>));
let settings: Reactive<GuildSettings> = reactive(JSON.parse(JSON.stringify(props.settings)));
let valid = ref(true);
let submitting = ref(false);
let punishments = computed(() => [
  {title: i18n.global.t('GuildModeration.punishments.mute'), value: 'mute'},
  {title: i18n.global.t('GuildModeration.punishments.kick'), value: 'kick'},
  {title: i18n.global.t('GuildModeration.punishments.ban'), value: 'ban'}
])
let tests: Reactive<Record<string, boolean>> = reactive({});
let testsThrottle: Reactive<Record<string, boolean>> = reactive({});
let testSnackbar = ref(false);
let testSuccess = ref(true);

const warnsRules = [
  (number: number) => (number > 0 && !(number % 1)) || i18n.global.t('GuildModeration.errors.invalidWarns'),
  (number: number) => (settings.warnsPunishments.filter(wp => wp.warns == number).length <= 1 ||
      i18n.global.t('GuildModeration.errors.duplicateWarns'))
]

function automodUpdated(result: SubmitResult, autoModeration: GuildAutoModeration) {
  if (result === 'success') settings.autoModeration = autoModeration
  emit('submitted', result, settings)
}

async function submit() {
  submitting.value = true;
  if (!settings.punishmentMessages.kick.message?.trim()?.length && !settings.punishmentMessages.kick.embed?.enabled)
    settings.punishmentMessages.kick.enabled = false
  if (!settings.punishmentMessages.ban.message?.trim()?.length && !settings.punishmentMessages.ban.embed?.enabled)
    settings.punishmentMessages.ban.enabled = false
  let response = await fetch(`${config.API}/private/guilds/${route.params.id}/moderation`,
      {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('token') as string,
          'Content-Type': 'application/json'
        }, body: JSON.stringify({
          muteRole: settings.muteRole,
          useTimeout: settings.useTimeout,
          warnsPunishments: settings.warnsPunishments,
          punishmentMessages: settings.punishmentMessages
        })
      })
  if (response.ok) emit('submitted', 'success', settings)
  else emit('submitted', 'error')
  submitting.value = false;
}

async function test(type: 'kick' | 'ban') {
  if (testsThrottle[type]) return
  tests[type] = true
  let response = await fetch(`${config.API}/private/guilds/${route.params.id}/tests/punishments`,
      {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('token') as string,
          'Content-Type': 'application/json'
        }, body: JSON.stringify({type})
      })
  tests[type] = false
  tests[type] = false
  testsThrottle[type] = true
  setTimeout(() => testsThrottle[type] = false, 10000)
  testSuccess.value = response.ok
  testSnackbar.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_form, {
      modelValue: _unref(valid),
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(valid) ? (valid).value = $event : valid = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('GuildModeration.subtitles.muteRole')), 1),
        _createVNode(_component_v_select, {
          modelValue: _unref(settings).muteRole,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(settings).muteRole) = $event)),
          class: "role-select mt-1",
          color: "primary",
          items: _unref(roles),
          "hide-details": "",
          label: _ctx.$t('GuildModeration.subtitles.selectRole')
        }, null, 8, ["modelValue", "items", "label"]),
        _createVNode(_component_v_checkbox, {
          modelValue: _unref(settings).useTimeout,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(settings).useTimeout) = $event)),
          class: "ma-0 pa-0 fit-content",
          color: "primary",
          "hide-details": "",
          label: _ctx.$t('GuildModeration.subtitles.useTimeout')
        }, null, 8, ["modelValue", "label"]),
        (_unref(settings).useTimeout)
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 0,
              class: "alert mb-3",
              border: "start",
              color: "alert",
              title: _ctx.$t('GuildModeration.subtitles.timeout'),
              variant: "tonal"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('GuildModeration.subtitles.timeoutDescription')), 1)
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('GuildModeration.subtitles.autoModeration')), 1),
        _createVNode(AutoModeration, {
          "auto-moderation": _unref(settings).autoModeration,
          roles: _unref(guild).roles,
          channels: _unref(guild).channels,
          onUpdate: automodUpdated
        }, null, 8, ["auto-moderation", "roles", "channels"]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('GuildModeration.subtitles.warnsPunishments')), 1),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(settings).warnsPunishments, (warnsPunishment, i) => {
            return (_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('GuildModeration.subtitles.punishment')) + " " + _toDisplayString(i + 1), 1),
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  size: "small",
                  onClick: ($event: any) => (_unref(settings).warnsPunishments.splice(i, 1))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "large",
                      color: "red"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("delete")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _createVNode(_component_v_text_field, {
                modelValue: warnsPunishment.warns,
                "onUpdate:modelValue": ($event: any) => ((warnsPunishment.warns) = $event),
                class: "warns-count mt-0",
                color: "primary",
                rules: warnsRules,
                label: _ctx.$t('GuildModeration.subtitles.warns')
              }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_v_select, {
                    modelValue: warnsPunishment.punishment.type,
                    "onUpdate:modelValue": ($event: any) => ((warnsPunishment.punishment.type) = $event),
                    color: "primary",
                    label: _ctx.$t('GuildModeration.subtitles.punishment'),
                    items: _unref(punishments)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "items"])
                ]),
                (warnsPunishment.punishment.type !== 'kick')
                  ? (_openBlock(), _createBlock(DurationPicker, {
                      key: 0,
                      modelValue: warnsPunishment.punishment.duration,
                      "onUpdate:modelValue": ($event: any) => ((warnsPunishment.punishment.duration) = $event),
                      class: "punishment-duration",
                      limit: 315360000000
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_v_divider)
            ]))
          }), 256)),
          (_unref(settings).warnsPunishments?.length < 10)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                class: "wp-add",
                color: "primary",
                variant: "outlined",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(settings).warnsPunishments.push({warns: 0, punishment: {type: 'kick', duration: 0}})))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    medium: "",
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("add")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('GuildModeration.subtitles.add')), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('GuildModeration.errors.warnsPunishmentsLimit')), 1))
        ]),
        (!_unref(guild).settings.boost)
          ? (_openBlock(), _createBlock(BoostAlert, {
              key: 1,
              class: "alert",
              text: _ctx.$t('GuildModeration.subtitles.boostDescription')
            }, null, 8, ["text"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('GuildModeration.subtitles.kickMessage')), 1),
              _createVNode(_component_v_switch, {
                modelValue: _unref(settings).punishmentMessages.kick.enabled,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(settings).punishmentMessages.kick.enabled) = $event)),
                color: "primary",
                "hide-details": "",
                label: _ctx.$t('GuildModeration.subtitles.enabled')
              }, null, 8, ["modelValue", "label"]),
              _createVNode(TemplateInput, {
                modelValue: _unref(settings).punishmentMessages.kick.message,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(settings).punishmentMessages.kick.message) = $event)),
                class: "template",
                counter: 1500,
                disabled: !_unref(settings).punishmentMessages.kick.enabled,
                variables: ['member', 'guild', 'moderator', 'punishment']
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode(EmbedInput, {
                modelValue: _unref(settings).punishmentMessages.kick.embed,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(settings).punishmentMessages.kick.embed) = $event)),
                class: "embed",
                disabled: !_unref(settings).punishmentMessages.kick.enabled,
                variables: ['member', 'guild', 'moderator', 'punishment']
              }, null, 8, ["modelValue", "disabled"]),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('GuildModeration.subtitles.banMessage')), 1),
              _createVNode(_component_v_switch, {
                modelValue: _unref(settings).punishmentMessages.ban.enabled,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(settings).punishmentMessages.ban.enabled) = $event)),
                color: "primary",
                "hide-details": "",
                label: _ctx.$t('GuildModeration.subtitles.enabled')
              }, null, 8, ["modelValue", "label"]),
              _createVNode(TemplateInput, {
                modelValue: _unref(settings).punishmentMessages.ban.message,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(settings).punishmentMessages.ban.message) = $event)),
                class: "template",
                counter: 1500,
                disabled: !_unref(settings).punishmentMessages.ban.enabled,
                variables: ['member', 'guild', 'moderator', 'punishment']
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode(EmbedInput, {
                modelValue: _unref(settings).punishmentMessages.ban.embed,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(settings).punishmentMessages.ban.embed) = $event)),
                class: "embed",
                disabled: !_unref(settings).punishmentMessages.ban.enabled,
                variables: ['member', 'guild', 'moderator', 'punishment']
              }, null, 8, ["modelValue", "disabled"]),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('GuildModeration.subtitles.tests')), 1),
              (_unref(settings).useTimeout)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    class: "alert",
                    border: "start",
                    color: "alert",
                    title: _ctx.$t('GuildModeration.subtitles.testsTitle'),
                    variant: "tonal"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('GuildModeration.subtitles.testsDescription')), 1)
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_v_btn, {
                  class: "test-button",
                  color: "primary",
                  variant: "tonal",
                  loading: _unref(tests).kick,
                  "prepend-icon": "person_remove",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (test('kick')))
                }, {
                  default: _withCtx(() => [
                    (_unref(testsThrottle).kick)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          activator: "parent",
                          location: "top",
                          "open-on-click": ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('GuildGreetings.subtitles.throttle')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('GuildModeration.subtitles.kickTest')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_v_btn, {
                  class: "test-button",
                  color: "primary",
                  variant: "tonal",
                  loading: _unref(tests).ban,
                  "prepend-icon": "block",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (test('ban')))
                }, {
                  default: _withCtx(() => [
                    (_unref(testsThrottle).ban)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          activator: "parent",
                          location: "top",
                          "open-on-click": ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('GuildGreetings.subtitles.throttle')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('GuildModeration.subtitles.banTest')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _createVNode(_component_v_snackbar, {
                modelValue: _unref(testSnackbar),
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(testSnackbar) ? (testSnackbar).value = $event : testSnackbar = $event)),
                color: "block"
              }, {
                actions: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    color: _unref(testSuccess) ? 'green' : 'pink',
                    variant: "text",
                    ripple: "",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_isRef(testSnackbar) //@ts-ignore
 ? testSnackbar.value = false : testSnackbar = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('GuildModeration.subtitles.close')), 1)
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(testSuccess) ? _ctx.$t('GuildModeration.subtitles.testCompleted') : _ctx.$t('GuildModeration.subtitles.testError')), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])),
        _createVNode(_component_v_btn, {
          class: "submit",
          disabled: _unref(valid) === false,
          loading: _unref(submitting),
          size: "large",
          color: "secondary",
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { class: "save-icon" }, {
              default: _withCtx(() => [
                _createTextVNode("save")
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('GuildEconomy.submit')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})